/*eslint no-console: ["error", { allow: ["log", "warn", "error"] }] */
'use strict';

class ReporteGamController {
  constructor($q, DataService, Message, $scope, $http, apiUrl, Loading, Storage,$log,baseUrl,DataTable) {
    'ngInject';

    this.$q = $q;
    this.$scope = $scope;
    this.$http = $http;
    this.apiUrl = apiUrl;
    this.DataService = DataService;
    this.Message = Message;
    this.Loading = Loading;
    this.Storage = Storage;
    this.log = $log
    this.baseUrl = baseUrl;
    this.DataTable = DataTable;
  }

  $onInit() {

    this.obtenerDatosSeguimiento();
  }


  obtenerDatosSeguimiento(){

    this.tableParams = this.DataTable.getParams(`reportes/gam-seguimiento`);
    // this.DataService.get(`reportes/gam-seguimiento`,{})
      // .then(response=>{
      //   if(response){
      //     console.log(response)
      //     this.datosGam = response.datos;
     
      //   }
      // })
  }

  generarPDF() {
    let tabla = document.getElementById('tabla1');

    this.DataService.pdf(`reportes/consejo`,{html:tabla.outerHTML},true).then((resp) => {
      if (resp) {
        
        window.open(resp,'ventana1','menu=0,tooltip=0,width=900px,height=700px,resize=0')
        // console.log(resp)
      }
    });
  }
}

export default ReporteGamController;



// WEBPACK FOOTER //
// ./src/app/components/reportes/reportesGam/repo-gam.controller.js